/* ==========================================================================
   Abrams - drobne poprawki JS motywu (ladowane po custom.js).
   ========================================================================== */

/* Karta produktu: dopasowanie wysokosci paska miniatur do wysokosci glownego
   zdjecia (desktop). Focal ustawia sztywny max-height paska, ktory nie sledzi
   naszego kwadratowego kadru - tu synchronizujemy go z aktualna wysokoscia zdjecia. */
(function () {
  var MQ = '(min-width: 1000px)';

  function sync() {
    var desktop = window.matchMedia(MQ).matches;
    document.querySelectorAll('.product--abrams-fiido').forEach(function (root) {
      var wrap = root.querySelector('.product__media-list-wrapper');
      var list = root.querySelector('.product__thumbnail-list');
      if (!list) return;
      if (desktop && wrap) {
        var h = Math.round(wrap.getBoundingClientRect().height);
        if (h > 0) list.style.maxHeight = h + 'px';
      } else {
        list.style.maxHeight = '';
      }
    });
  }

  // Odczyt po przeliczeniu layoutu (unika chwilowej rozbieznosci przy resize).
  var raf;
  function scheduleSync() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(sync);
  }

  function init() {
    sync();
    // Kadr moze zmienic wysokosc gdy zdjecie doladuje sie asynchronicznie.
    var wrap = document.querySelector('.product--abrams-fiido .product__media-list-wrapper');
    if (wrap && 'ResizeObserver' in window) {
      new ResizeObserver(scheduleSync).observe(wrap);
    }
    setTimeout(sync, 300);
    setTimeout(sync, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', scheduleSync);
  window.addEventListener('resize', scheduleSync);
})();

/* Karta produktu: "Kup teraz" -> permalink /cart/{variant_id}:{qty} (dodaje produkt
   i przechodzi prosto do kasy). Czyta aktualny wariant + ilosc z formularza produktu. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-abrams-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var form = document.querySelector('product-form form')
      || document.querySelector('form[action*="/cart/add"]')
      || (document.getElementById('AddToCart') && document.getElementById('AddToCart').closest('form'));
    if (!form) { window.location.href = '/cart'; return; }
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var id = idEl && idEl.value;
    var qty = (qtyEl && parseInt(qtyEl.value, 10)) || 1;
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    window.location.href = '/cart/' + id + ':' + qty;
  });
})();

/* Badge oceny -> sekcja opinii: plynne przewijanie zamiast skoku.
   scrollIntoView respektuje scroll-margin-top z klasy .anchor, wiec sekcja nie
   chowa sie pod przyklejonym headerem. Przy wlaczonym ograniczeniu ruchu w
   systemie zostaje skok - animacja bywa tam zrodlem mdlosci. */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#opinie-allegro"]');
    if (!link) return;

    var target = document.getElementById('opinie-allegro');
    if (!target) return;

    e.preventDefault();

    var before = window.pageYOffset;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#opinie-allegro');

    /* Siatka bezpieczenstwa: gdyby animacja nie ruszyla (stara przegladarka,
       zablokowane animacje), po chwili wykonujemy zwykly skok. Bez tego klik
       w badge nie robilby nic, bo default jest juz zablokowany. */
    if (!reduce) {
      window.setTimeout(function () {
        if (Math.abs(window.pageYOffset - before) < 2) {
          target.scrollIntoView({ block: 'start' });
        }
      }, 300);
    }
  });
})();
